// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"4ff64a87","216":"16709152","810":"53caa1af","862":"e1545cb9","917":"f209a8c7","979":"600da401"}[chunkId] + ".chunk.js";
};